import { __makeTemplateObject, __assign } from 'tslib';
import React from 'react';
import { css, styled } from 'styled-components';
import { resets } from '../utils/index.js';

var legendResets = css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n  ", "\n  max-width: 100%;\n"], ["\n  ", "\n  ", "\n  max-width: 100%;\n"])), resets.normalize.html, resets.common);
var Legend = function Legend(props) {
  return /*#__PURE__*/React.createElement("legend", __assign({}, props));
};
var HtmlLegend = styled(Legend).withConfig({
  componentId: "sc-l026dr-0"
})(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), legendResets);
var templateObject_1, templateObject_2;

export { HtmlLegend };
//# sourceMappingURL=HtmlLegend.js.map
